import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const StyledMenuTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontWeight: 700,
  lineHeight: "20px",
  verticalAlign: "middle",
  color: "#212121",
  // Desktop default
  fontSize: "18px",

  // Tablet
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },

  // Mobile
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

export const StyledMenuSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontWeight: 500,
  lineHeight: "16px",
  verticalAlign: "middle",

  // Desktop default
  fontSize: "15px",

  // Tablet
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },

  // Mobile
  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
  },
}));

export const StyledMenuButton = styled("button")`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  /* ⬇️ inverted */
  background-color: #ffffff;
  border: 1px solid #252427;
  padding: 6px 12px;

  font-family: Montserrat;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: #252427; /* ⬅️ black text */
  text-align: center;
  vertical-align: middle;

  transition: background 0.2s ease, color 0.2s ease;

  /* Ensure icon color follows text color */
  & svg {
    color: inherit;
  }
`;

export const ArrowCircular = styled("span")`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #000000;

  font-family: "Font Awesome 6 Pro";
  font-weight: 900;
  font-size: 12px;
  line-height: 20px;
  vertical-align: middle;
  color: white;
`;

export const StyledMenuLink = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #252427;

  padding: 3px 0;
  border-radius: 6px;

  &:hover {
    background-color: #f4f4f4;
  }
`;

export const StyledMenuHeading = styled(Typography)`
  font-family: Montserrat;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  vertical-align: middle;
  background: white;
  color: #848484; /* ensures text is visible on gray */
  width: 100%; /* optional: full-width heading */
  padding: 8px 0px; /* optional spacing for better UX */
  border-radius: 8px; /* optional rounded look */
`;

export const AideCardTitle = styled("div")`
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #252427;
`;

export const AideCardSubtitle = styled("div")`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #252427;
`;
